export const RESET_APP_STATE = "RESET_APP_STATE";
export const POST_LOGIN_START = "POST_LOGIN_START";
export const POST_LOGIN_SUCCESS = "POST_LOGIN_SUCCESS";
export const POST_LOGIN_ERROR = "POST_LOGIN_ERROR";

export const POST_SIGNUP_START = "POST_SIGNUP_START";
export const POST_SIGNUP_SUCCESS = "POST_SIGNUP_SUCCESS";
export const POST_SIGNUP_ERROR = "POST_SIGNUP_ERROR";

export const POST_FORGOT_PASSWORD_START = "POST_FORGOT_PASSWORD_START";
export const POST_FORGOT_PASSWORD_SUCCESS = "POST_FORGOT_PASSWORD_SUCCESS";
export const POST_FORGOT_PASSWORD_ERROR = "POST_FORGOT_PASSWORD_ERROR";

export const POST_RESET_PASSWORD_START = "POST_RESET_PASSWORD_START";
export const POST_RESET_PASSWORD_SUCCESS = "POST_RESET_PASSWORD_SUCCESS";
export const POST_RESET_PASSWORD_ERROR = "POST_RESET_PASSWORD_ERROR";

export const POST_OTP_VERIFICATION_START = "POST_OTP_VERIFICATION_START";
export const POST_OTP_VERIFICATION_SUCCESS = "POST_OTP_VERIFICATION_SUCCESS";
export const POST_OTP_VERIFICATION_ERROR = "POST_OTP_VERIFICATION_ERROR";

export const SEND_OTP_START = "SEND_OTP_START";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_ERROR = "SEND_OTP_ERROR";

export const STEP_ONE_START = "STEP_ONE_START";
export const STEP_ONE_SUCCESS = "STEP_ONE_SUCCESS";
export const STEP_ONE_ERROR = "STEP_ONE_ERROR";

export const STEP_TWO_START = "STEP_TWO_START";
export const STEP_TWO_SUCCESS = "STEP_TWO_SUCCESS";
export const STEP_TWO_ERROR = "STEP_TWO_ERROR";

export const STEP_THREE_START = "STEP_THREE_START";
export const STEP_THREE_SUCCESS = "STEP_THREE_SUCCESS";
export const STEP_THREE_ERROR = "STEP_THREE_ERROR";

export const STEP_FOUR_START = "STEP_FOUR_START";
export const STEP_FOUR_SUCCESS = "STEP_FOUR_SUCCESS";
export const STEP_FOUR_ERROR = "STEP_FOUR_ERROR";

export const STEP_FIVE_START = "STEP_FIVE_START";
export const STEP_FIVE_SUCCESS = "STEP_FIVE_SUCCESS";
export const STEP_FIVE_ERROR = "STEP_FIVE_ERROR";

export const STEP_SIX_START = "STEP_SIX_START";
export const STEP_SIX_SUCCESS = "STEP_SIX_SUCCESS";
export const STEP_SIX_ERROR = "STEP_SIX_ERROR";

export const GET_STEP_ONE_START = "GET_STEP_ONE_START";
export const GET_STEP_ONE_SUCCESS = "GET_STEP_ONE_SUCCESS";
export const GET_STEP_ONE_ERROR = "GET_STEP_ONE_ERROR";

export const GET_STEP_TWO_START = "GET_STEP_TWO_START";
export const GET_STEP_TWO_SUCCESS = "GET_STEP_TWO_SUCCESS";
export const GET_STEP_TWO_ERROR = "GET_STEP_TWO_ERROR";

export const GET_STEP_THREE_START = "GET_STEP_THREE_START";
export const GET_STEP_THREE_SUCCESS = "GET_STEP_THREE_SUCCESS";
export const GET_STEP_THREE_ERROR = "GET_STEP_THREE_ERROR";

export const GET_STEP_FOUR_START = "GET_STEP_FOUR_START";
export const GET_STEP_FOUR_SUCCESS = "GET_STEP_FOUR_SUCCESS";
export const GET_STEP_FOUR_ERROR = "GET_STEP_FOUR_ERROR";

export const GET_STEP_FIVE_START = "GET_STEP_FIVE_START";
export const GET_STEP_FIVE_SUCCESS = "GET_STEP_FIVE_SUCCESS";
export const GET_STEP_FIVE_ERROR = "GET_STEP_FIVE_ERROR";

export const GET_STEP_SIX_START = "GET_STEP_SIX_START";
export const GET_STEP_SIX_SUCCESS = "GET_STEP_SIX_SUCCESS";
export const GET_STEP_SIX_ERROR = "GET_STEP_SIX_ERROR";

export const GLOBAL_FEED_CREATION_START = "GLOBAL_FEED_CREATION_START";
export const GLOBAL_FEED_CREATION_SUCCESS = "GLOBAL_FEED_CREATION_SUCCESS";
export const GLOBAL_FEED_CREATION_ERROR = "GLOBAL_FEED_CREATION_ERROR";
export const GLOBAL_FEED_CREATION_RESET = "GLOBAL_FEED_CREATION_RESET";

export const GET_MY_GLOBAL_FEEDS_START = "GET_MY_GLOBAL_FEEDS_START";
export const GET_MY_GLOBAL_FEEDS_SUCCESS = "GET_MY_GLOBAL_FEEDS_SUCCESS";
export const GET_MY_GLOBAL_FEEDS_ERROR = "GET_MY_GLOBAL_FEEDS_ERROR";

export const LOCAL_FEED_CREATION_START = "LOCAL_FEED_CREATION_START";
export const LOCAL_FEED_CREATION_SUCCESS = "LOCAL_FEED_CREATION_SUCCESS";
export const LOCAL_FEED_CREATION_ERROR = "LOCAL_FEED_CREATION_ERROR";
export const LOCAL_FEED_CREATION_RESET = "LOCAL_FEED_CREATION_RESET";

export const GET_MY_LOCAL_FEEDS_START = "GET_MY_LOCAL_FEEDS_START";
export const GET_MY_LOCAL_FEEDS_SUCCESS = "GET_MY_LOCAL_FEEDS_SUCCESS";
export const GET_MY_LOCAL_FEEDS_ERROR = "GET_MY_LOCAL_FEEDS_ERROR";

export const LOGOUT_START = "LOGOUT_START";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

export const CURRENT_USER_GET_START = "CURRENT_USER_GET_START";
export const CURRENT_USER_GET_SUCCESS = "CURRENT_USER_GET_SUCCESS";
export const CURRENT_USER_GET_ERROR = "CURRENT_USER_GET_ERROR";
export const CURRENT_USER_GET_RESET = "CURRENT_USER_GET_RESET";

export const UPDATE_USER_DETAILS_START = "UPDATE_USER_DETAILS_START";
export const UPDATE_USER_DETAILS_SUCCESS = "UPDATE_USER_DETAILS_SUCCESS";
export const UPDATE_USER_DETAILS_ERROR = "UPDATE_USER_DETAILS_ERROR";

export const GET_REACH_DATA_DISTANCE_START = "GET_REACH_DATA_DISTANCE_START";
export const GET_REACH_DATA_DISTANCE_SUCCESS = "GET_REACH_DATA_DISTANCE_SUCCESS";
export const GET_REACH_DATA_DISTANCE_ERROR = "GET_REACH_DATA_DISTANCE_ERROR";

export const POST_LIKES_START = "POST_LIKES_START";
export const POST_LIKES_SUCCESS = "POST_LIKES_SUCCESS";
export const POST_LIKES_ERROR = "POST_LIKES_ERROR";


export const POST_COMMENTS_START = "POST_COMMENTS_START";
export const POST_COMMENTS_SUCCESS = "POST_COMMENTS_SUCCESS";
export const POST_COMMENTS_ERROR = "POST_COMMENTS_ERROR";

export const GET_COMMENTS_START = "GET_COMMENTS_START";
export const GET_COMMENTS_SUCCESS = "GET_COMMENTS_SUCCESS";
export const GET_COMMENTS_ERROR = "GET_COMMENTS_ERROR";

export const GET_RADIUS_DATA_START = "GET_RADIUS_DATA_START";
export const GET_RADIUS_DATA_SUCCESS = "GET_RADIUS_DATA_SUCCESS";
export const GET_RADIUS_DATA_ERROR = "GET_RADIUS_DATA_ERROR";

export const GET_RADIUS_DETAILS_START = "GET_RADIUS_DETAILS_START";
export const GET_RADIUS_DETAILS_SUCCESS = "GET_RADIUS_DETAILS_SUCCESS";
export const GET_RADIUS_DETAILS_ERROR = "GET_RADIUS_DETAILS_ERROR";

export const CHANGE_PASSWORD_START = "CHANGE_PASSWORD_START";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const GET_BUSINESS_START = "GET_BUSINESS_START";
export const GET_BUSINESS_SUCCESS = "GET_BUSINESS_SUCCESS";
export const GET_BUSINESS_ERROR = "GET_BUSINESS_ERROR";

export const GET_OFFERS_START = "GET_OFFERS_START";
export const GET_OFFERS_SUCCESS = "GET_OFFERS_SUCCESS";
export const GET_OFFERS_ERROR = "GET_OFFERS_ERROR";

export const GET_FAVORITES_START = "GET_FAVORITES_START";
export const GET_FAVORITES_SUCCESS = "GET_FAVORITES_SUCCESS";
export const GET_FAVORITES_ERROR = "GET_FAVORITES_ERROR";

export const POST_OFFER_START = "POST_OFFER_START";
export const POST_OFFER_SUCCESS = "POST_OFFER_SUCCESS";
export const POST_OFFER_ERROR = "POST_OFFER_ERROR";
export const POST_OFFER_RESET = "POST_OFFER_RESET";

export const UPDATE_OFFER_START = "UPDATE_OFFER_START";
export const UPDATE_OFFER_SUCCESS = "UPDATE_OFFER_SUCCESS";
export const UPDATE_OFFER_ERROR = "UPDATE_OFFER_ERROR";
export const UPDATE_OFFER_RESET = "UPDATE_OFFER_RESET";

export const DELETE_OFFER_START = "DELETE_OFFER_START";
export const DELETE_OFFER_SUCCESS = "DELETE_OFFER_SUCCESS";
export const DELETE_OFFER_ERROR = "DELETE_OFFER_ERROR";

export const GET_FOLLOWED_BUSINESSES_START = "GET_FOLLOWED_BUSINESSES_START";
export const GET_FOLLOWED_BUSINESSES_SUCCESS = "GET_FOLLOWED_BUSINESSES_SUCCESS";
export const GET_FOLLOWED_BUSINESSES_ERROR = "GET_FOLLOWED_BUSINESSES_ERROR";

export const POST_REVIEWS_START = "POST_REVIEWS_START";
export const POST_REVIEWS_SUCCESS = "POST_REVIEWS_SUCCESS";
export const POST_REVIEWS_ERROR = "POST_REVIEWS_ERROR";
export const POST_REVIEWS_RESET = "POST_REVIEWS_RESET"

export const DELETE_REVIEWS_START = "DELETE_REVIEWS_START";
export const DELETE_REVIEWS_SUCCESS = "DELETE_REVIEWS_SUCCESS";
export const DELETE_REVIEWS_ERROR = "DELETE_REVIEWS_ERROR";

export const GET_REVIEWS_START = "GET_REVIEWS_START";
export const GET_REVIEWS_SUCCESS = "GET_REVIEWS_SUCCESS";
export const GET_REVIEWS_ERROR = "GET_REVIEWS_ERROR";

export const FOLLOW_BUSINESS_START = "FOLLOW_BUSINESS_START";
export const FOLLOW_BUSINESS_SUCCESS = "FOLLOW_BUSINESS_SUCCESS";
export const FOLLOW_BUSINESS_ERROR = "FOLLOW_BUSINESS_ERROR";

export const GET_JOBS_START = "GET_JOBS_START";
export const GET_JOBS_SUCCESS = "GET_JOBS_SUCCESS";
export const GET_JOBS_ERROR = "GET_JOBS_ERROR";

export const POST_JOB_START = "POST_JOB_START";
export const POST_JOB_SUCCESS = "POST_JOB_SUCCESS";
export const POST_JOB_ERROR = "POST_JOB_ERROR";
export const POST_JOB_RESET = "POST_JOB_RESET";

export const UPDATE_JOB_START = "UPDATE_JOB_START";
export const UPDATE_JOB_SUCCESS = "UPDATE_JOB_SUCCESS";
export const UPDATE_JOB_ERROR = "UPDATE_JOB_ERROR";
export const UPDATE_JOB_RESET = "UPDATE_JOB_RESET";

export const DELETE_JOB_START = "DELETE_JOB_START";
export const DELETE_JOB_SUCCESS = "DELETE_JOB_SUCCESS";
export const DELETE_JOB_ERROR = "DELETE_JOB_ERROR";

export const INITIATE_PAYMENT_START = "INITIATE_PAYMENT_START";
export const INITIATE_PAYMENT_SUCCESS = "INITIATE_PAYMENT_SUCCESS";
export const INITIATE_PAYMENT_ERROR = "INITIATE_PAYMENT_ERROR";
export const INITIATE_PAYMENT_RESET = "INITIATE_PAYMENT_RESET";

export const CHECK_PAYMENT_STATUS_START = "CHECK_PAYMENT_STATUS_START";
export const CHECK_PAYMENT_STATUS_SUCCESS = "CHECK_PAYMENT_STATUS_SUCCESS";
export const CHECK_PAYMENT_STATUS_ERROR = "CHECK_PAYMENT_STATUS_ERROR";

export const GET_SUBSCRIPTION_PLANS_START = "GET_SUBSCRIPTION_PLANS_START";
export const GET_SUBSCRIPTION_PLANS_SUCCESS = "GET_SUBSCRIPTION_PLANS_SUCCESS";
export const GET_SUBSCRIPTION_PLANS_ERROR = "GET_SUBSCRIPTION_PLANS_ERROR";

export const SUBSCRIBE_PLAN_START = "SUBSCRIBE_PLAN_START";
export const SUBSCRIBE_PLAN_SUCCESS = "SUBSCRIBE_PLAN_SUCCESS";
export const SUBSCRIBE_PLAN_ERROR = "SUBSCRIBE_PLAN_ERROR";
export const SUBSCRIBE_PLAN_RESET = "SUBSCRIBE_PLAN_RESET";

export const SET_SELECTED_PLAN = "SET_SELECTED_PLAN";
export const CLEAR_SELECTED_PLAN = "CLEAR_SELECTED_PLAN";

export const GET_TERMS_AND_CONDITIONS_START = "GET_TERMS_AND_CONDITIONS_START";
export const GET_TERMS_AND_CONDITIONS_SUCCESS = "GET_TERMS_AND_CONDITIONS_SUCCESS";
export const GET_TERMS_AND_CONDITIONS_ERROR = "GET_TERMS_AND_CONDITIONS_ERROR";

export const GET_PRIVACY_POLICY_START = "GET_PRIVACY_POLICY_START";
export const GET_PRIVACY_POLICY_SUCCESS = "GET_PRIVACY_POLICY_SUCCESS";
export const GET_PRIVACY_POLICY_ERROR = "GET_PRIVACY_POLICY_ERROR";

export const GET_CANCELLATION_REFUND_POLICY_START = "GET_CANCELLATION_REFUND_POLICY_START";
export const GET_CANCELLATION_REFUND_POLICY_SUCCESS = "GET_CANCELLATION_REFUND_POLICY_SUCCESS";
export const GET_CANCELLATION_REFUND_POLICY_ERROR = "GET_CANCELLATION_REFUND_POLICY_ERROR";

export const GET_RELATED_BUSINESSES_START = "GET_RELATED_BUSINESSES_START";
export const GET_RELATED_BUSINESSES_SUCCESS = "GET_RELATED_BUSINESSES_SUCCESS";
export const GET_RELATED_BUSINESSES_ERROR = "GET_RELATED_BUSINESSES_ERROR";

export const GET_PAYMENT_HISTORY_START = "GET_PAYMENT_HISTORY_START";
export const GET_PAYMENT_HISTORY_SUCCESS = "GET_PAYMENT_HISTORY_SUCCESS";
export const GET_PAYMENT_HISTORY_ERROR = "GET_PAYMENT_HISTORY_ERROR";

export const CANCEL_SUBSCRIPTION_START = "CANCEL_SUBSCRIPTION_START";
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS";
export const CANCEL_SUBSCRIPTION_ERROR = "CANCEL_SUBSCRIPTION_ERROR";
export const CANCEL_SUBSCRIPTION_RESET = "CANCEL_SUBSCRIPTION_RESET";

export const POST_BUSINESS_UPGRADE_REQUEST_START   = "POST_BUSINESS_UPGRADE_REQUEST_START";
export const POST_BUSINESS_UPGRADE_REQUEST_SUCCESS = "POST_BUSINESS_UPGRADE_REQUEST_SUCCESS";
export const POST_BUSINESS_UPGRADE_REQUEST_ERROR   = "POST_BUSINESS_UPGRADE_REQUEST_ERROR";
export const POST_BUSINESS_UPGRADE_REQUEST_RESET   = "POST_BUSINESS_UPGRADE_REQUEST_RESET";

export const VERIFY_PAYMENT_START = "VERIFY_PAYMENT_START";
export const VERIFY_PAYMENT_SUCCESS = "VERIFY_PAYMENT_SUCCESS";
export const VERIFY_PAYMENT_ERROR = "VERIFY_PAYMENT_ERROR";
